import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.newsPage.pageTitle',
    defaultMessage: 'News',
    description: 'Title page',
  },

  serviceNews: {
    id: 'features.newsPage.serviceNews',
    defaultMessage: 'News di servizio',
    description: 'service News',
  },

  tecnicalNews: {
    id: 'features.newsPage.tecnicalNews',
    defaultMessage: 'News tecnica',
    description: 'tecnical News',
  },

  commercialNews: {
    id: 'features.newsPage.commercialNews',
    defaultMessage: 'News commerciale',
    description: 'commercial News',
  },

  serviceAvailability: {
    id: 'features.newsPage.serviceAvailability',
    defaultMessage: 'Disponibilità servizio',
    description: 'service Availability',
  },

  tecnicalService: {
    id: 'features.newsPage.tecnicalService',
    defaultMessage: 'Servizio tecnico',
    description: 'tecnical Service',
  },

  commercialAnalysis: {
    id: 'features.newsPage.commercialAnalysis',
    defaultMessage: 'Analisi commerciale',
    description: 'commercial Analysis',
  },

  variousService: {
    id: 'features.newsPage.variousService',
    defaultMessage: 'Servizio vario',
    description: 'various Service',
  },

  viewButtonLabel: {
    id: 'features.newsPage.viewButtonLabel',
    defaultMessage: 'Visualizza',
    description: 'view Button Label',
  },

  closeButtonLabel: {
    id: 'features.newsPage.closeButtonLabel',
    defaultMessage: 'Chiudi',
    description: 'close Button Label',
  },

  othersNews: {
    id: 'features.newsPage.othersNews',
    defaultMessage: 'News varie',
    description: 'others News',
  },

  noNews: {
    id: 'features.newsPage.noNews',
    defaultMessage: 'Nessuna news presente',
    description: 'no News',
  },
});
